import { Injectable } from '@angular/core';
import { FuseMediaChange, FuseMediaObserver } from './fuse-media-observer.service';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FuseMatchMediaService {
  public activeMediaQuery: string;
  public onMediaChange: BehaviorSubject<string> = new BehaviorSubject<string>('');

  /**
   * Constructor
   *
   * @param {ObservableMedia} _observableMedia
   */
  public constructor(private _mediaObserver: FuseMediaObserver) {
    // Set the defaults
    this.activeMediaQuery = '';

    // Initialize
    this._init();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Initialize
   *
   * @private
   */
  private _init(): void {
    this._mediaObserver
      .asObservable()
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((change: FuseMediaChange[]) => {
        if (change.length && this.activeMediaQuery !== change[0].mqAlias) {
          this.activeMediaQuery = change[0].mqAlias;
          this.onMediaChange.next(change[0].mqAlias);
        }
      });
  }
}
